<script>
  /**
   * Created by uiuifree on 2017/04/06.
   */
  import axios from 'axios'
  import VueCookie from 'vue-cookie'

  var instance = axios.create({
//     timeout: 1000
    headers: {'Authorization': VueCookie.get('token')}
  })

  const apiDomain = process.env.API_ROOT

  export default {
    // AuthAPI
    login: async function (data) {
      var querystring = require('querystring')
      return await axios.post(apiDomain + 'auth/admin', querystring.stringify(data))
    },
    token: function () {
      // トークン切れてたらそもそもアクセスできないので同期しない
      return instance.get(apiDomain + 'token/admin')
    },
    error (response) {
      var errors = false
      // 共通エラー処理
      var errorResponse = response.response || false
      if (!errorResponse && !response.data) {
        errors = [['API接続に失敗しました。']]
      }
      if (errorResponse) {
        errors = errorResponse.data.errors || [['API接続に失敗しました。(出力メッセージ無)']]
      }
      return errors
    },
    image: {
      upload: async function (foldername, filename, formData, config) {
        return await instance.post(apiDomain + 'image/upload/' + foldername + '/' + filename, formData, config)
      }
    },
    // 都道府県市区町村
    getCityByPrefecture: async function (id) {
      return await instance.get(apiDomain + 'cities/prefecture/' + id)
    },
    // CompanyAPI
    contact: {
      search: async function (data) {
        var query = serialize(data)
        return await instance.get(apiDomain + 'admin/contact?' + query)
      }
    },
    // CompanyAPI
    company: {
      search (params) {
        return instance.get(apiDomain + 'admin/company', {
          params
        })
      },
      get (id) {
        return instance.get(`${apiDomain}admin/company/${id}`)
      },
      post (data) {
        return instance.post(apiDomain + 'admin/company', data)
      },
      put (id, data) {
        return instance.put(`${apiDomain}admin/company/${id}`, data)
      },
      corporateNumber (id) {
        return instance.get(`${apiDomain}admin/company/corporate_number/${id}`)
      }
    },
    // CompanyGroupAPI
    companyGroup: {
      search: async function (data) {
        var query = serialize(data)
        return await instance.get(apiDomain + 'company/group?' + query)
      },
      get: async function (id) {
        return await instance.get(apiDomain + 'company/group/' + id)
      },
      post: async function (data) {
        var d = serialize(data)
        return await instance.post(apiDomain + 'company/group', d)
      },
      put: async function (id, data) {
        var d = serialize(data)
        return await instance.put(apiDomain + 'company/group/' + id, d)
      },
      remove: async function (id) {
        return await instance.delete(apiDomain + 'company/group/' + id)
      }
    },
    // MasterPrefectureAPI
    prefecture: {
      list: async function (data) {
        var query = serialize(data)
        return await instance.get(apiDomain + 'prefecture?' + query)
      },
      all: async function () {
        return await instance.get(apiDomain + 'prefecture')
      }
    },
    city: {
      search: async function (data) {
        return await instance.get(apiDomain + 'city', data)
      },
      prefecture: async function (id) {
        return await instance.get(apiDomain + 'prefecture/ ' + id + '/city')
      }
    },
    stationLine: {
      search: async function (data) {
        var query = serialize(data)
        return await instance.get(apiDomain + 'station/line?' + query)
      }
    },
    // ReviewAPI
    review: {
      search: async function (data) {
        var query = serialize(data)
        return await instance.get(apiDomain + 'review?' + query)
      },
      get: async function (id) {
        return await instance.get(apiDomain + 'admin/review/' + id)
      },
      post: async function (data) {
        return await instance.post(apiDomain + 'admin/review', data)
      },
      put: async function (id, data) {
        return await instance.put(apiDomain + 'admin/review/' + id, data)
      },
      updateCompany (data) {
        return instance.put(apiDomain + 'admin/review/company', data)
      }
    },
    // MemberAPI
    member: {
      search: async function (data) {
        var query = serialize(data)
        return await instance.get(apiDomain + 'admin/member?' + query)
      },
      csv: async function (data) {
        var query = serialize(data)
        return await instance.get(apiDomain + 'member/csv?' + query)
      },
      csvEntryAfter: async function (data) {
        var query = serialize(data)
        return await instance.get(apiDomain + 'member/csv/entry/after?' + query)
      },
      get: async function (id) {
        return await instance.get(apiDomain + 'admin/member/' + id)
      },
      getOnlyTrashed: async function (id) {
        return await instance.get(apiDomain + 'member/' + id + '/trashed')
      },
      post: async function (data) {
        return await instance.post(apiDomain + 'member', data)
      },
      put: async function (id, data) {
        return await instance.put(apiDomain + 'admin/member/' + id, data)
      },
      remove: async function (id) {
        return await instance.delete(apiDomain + 'member/' + id)
      },
      removeForce: async function (id) {
        return await instance.delete(apiDomain + 'member/' + id + '/force')
      }
    },
    //
    // Tag取得が根幹の為、非同期にしない
    tags: function () {
      return instance.get(apiDomain + 'admin/tag')
    }
  }

  function serialize (data) {
    var key, value, type, i, max
    var encode = window.encodeURIComponent
    var query = ''
    for (key in data) {
      value = data[key]
      if (typeof (value) === 'object' && value instanceof Array) {
        type = 'array'
      } else {
        type = typeof (value)
      }
      switch (type) {
        case 'undefined':
          // キーのみ
          query += key
          break
        case 'array':
          // 配列
          for (i = 0, max = value.length; i < max; i++) {
            query += key + '[]'
            query += '='
            query += encode(value[i])
            query += '&'
          }
          query = query.substr(0, query.length - 1)
          break
        case 'object':
          // ハッシュ
          for (i in value) {
            query += key + '[' + i + ']'
            query += '='
            query += encode(value[i])
            query += '&'
          }
          query = query.substr(0, query.length - 1)
          break
        default:
          query += key
          query += '='
          query += encode(value)
          break
      }
      query += '&'
    }
    query = query.substr(0, query.length - 1)
    return query
  }

</script>



// WEBPACK FOOTER //
// Api.vue?096ad72e